// Shared completion, failure, and running frame for V3 write cards.
import { type ReactNode } from 'react';

import { CardTransition } from '@apps/web/features/phoebe_chat_v3/ui/primitives/card_transition';
import {
    CompactReceipt,
    type ReceiptStatus,
    type ReceiptSurface,
} from '@apps/web/features/phoebe_chat_v3/ui/primitives/compact_receipt';
import { ResolvedReferenceText } from '@apps/web/features/phoebe_chat_v3/ui/primitives/reference_badge';

export function ActionResultCard({
    title,
    summary,
    status,
    notices = [],
    children,
    surface = 'action',
}: Readonly<{
    readonly title: string;
    readonly summary?: string;
    readonly status: ReceiptStatus;
    readonly notices?: ReadonlyArray<string>;
    readonly children?: ReactNode;
    readonly surface?: ReceiptSurface;
}>): ReactNode {
    return (
        <CardTransition transitionKey={status}>
            <CompactReceipt
                surface={surface}
                title={title}
                status={status}
                summary={
                    summary === undefined ? undefined : (
                        <ResolvedReferenceText text={summary} />
                    )
                }
            >
                {notices.length > 0 && (
                    <ul className="text-muted-foreground text-v3-chat mt-3 list-disc space-y-1 pl-4">
                        {notices.map((notice, index) => (
                            <li key={index}>
                                <ResolvedReferenceText text={notice} />
                            </li>
                        ))}
                    </ul>
                )}
                {children}
            </CompactReceipt>
        </CardTransition>
    );
}
